import { registerWorkflowActions } from './actionToSignalMapping';
import { useEffect } from 'react';

export const useRegisterWorkflowActions = workflowActions => {
    useEffect(() => {
        registerWorkflowActions(workflowActions);
        /* eslint-disable-next-line react-hooks/exhaustive-deps --
         * See aka.ms/mini-lint-errors
         *	> React Hook useEffect has a missing dependency: 'workflowActions'. Either include it or remove the dependency array. */
    }, []);
};
